import { IChildrenProps } from 'interface/cmn/commonInfo';
import { IProjectInfoAction, IProjectInfoInitialStateProps } from 'interface/project/projectInfo';
import { createContext, Dispatch } from 'react';
import { projectInfoInitalState, projectInfoReducer } from 'libs/projectUtils';
import { CmnContextProvider, useDispatchProvider, useStateProvider } from './CmnContextProvider';

const ProjectInfoDispatchContext = createContext<Dispatch<IProjectInfoAction> | null>(null);
const ProjectInfoStateContext = createContext<IProjectInfoInitialStateProps | null>(null);

export function ProjectInfoProvider({ children }: IChildrenProps): JSX.Element {
  return (
    <CmnContextProvider
      reducer={projectInfoReducer}
      initialState={projectInfoInitalState}
      stateContext={ProjectInfoStateContext}
      dispatchContext={ProjectInfoDispatchContext}
    >
      {children}
    </CmnContextProvider>
  );
}

export function useProjectInfoState(): IProjectInfoInitialStateProps {
  return useStateProvider(ProjectInfoStateContext, 'projectInfo');
}
export function useProjectInfoDispatch(): Dispatch<IProjectInfoAction> {
  return useDispatchProvider(ProjectInfoDispatchContext, 'projectInfo');
}
